// NEW: UI_REVAMP
export const RECORD_TEXT_COLORS = {
	primary: '#111111',
	secondary: '#545454',
	muted: '#666666',
	placeholder: '#B0A8C9',
	link: '#2553FF',
	white: '#FFFFFF',
	danger: '#D7212C',
};

export const RECORD_GRADIENTS = {
	greenText: 'linear-gradient(180deg, #01A13D 0%, #09632B 100%)',
	failedText: 'linear-gradient(180deg, #D81A80 0%, #E81B22 100%)',
	decreaseAmountGradient: 'radial-gradient(circle at 50% 50%, #E72F69 0%, #EA4C76 100%)',
	goldBorder:
		'linear-gradient(180deg, #F5D7A9 0%, #E28E10 10.42%, #E3CA89 25%, #E2A74C 69.79%, #4D3A1A 85.42%, #F5D7A9 100%)',
	purpleWhiteBorder: 'linear-gradient(180deg, #A397F2 0%, #FFFFFF 100%)',
	voidShellBorder: 'linear-gradient(180deg, #A397F2 0%, #FFFFFF 30%)',
	filterActive: 'linear-gradient(180deg, #FEDD8B 0%, #F5A911 100%)',
	historyCardSurface: 'linear-gradient(180deg, #F9FBFF 0%, #EEF6FF 100%)',
	detailCardSurface: 'linear-gradient(180deg, #FDFEFF 0%, #EFF6FF 100%)',
	straightBadge: 'linear-gradient(180deg, #FCE007 0%, #F99D20 100%)',
	rambleBadge: 'linear-gradient(180deg, #D81985 0%, #E81A1E 100%)',
	voidEnabled: 'radial-gradient(circle at 50% 50%, #E72F2F 0%, #EA4C4C 100%)',
	voidDisabled: 'linear-gradient(180deg, #B2B1B1 0%, #B2B1B1 100%)',
};

export const RECORD_SURFACES = {
	filterBorder: '#EFEAFB',
	filterFocus: '#D9CFFF',
	voidShell: 'rgba(238, 233, 254, 0.5)',
};

export const RECORD_SHADOWS = {
	goldCard: '0 3px 8px rgba(100, 72, 180, 0.18)',
	filterActive: '0 4px 8px rgba(245, 169, 17, 0.24)',
	purpleWhite: '0 0 10px 0 rgba(0, 49, 152, 0.2)',
	voidEnabled:
		'inset 0 5px 10.5px rgba(244, 191, 191, 0.75), inset 0 0 5.9px rgba(235, 235, 235, 0.95), 0 4px 10px rgba(231, 47, 47, 0.18)',
	voidDisabled:
		'inset 0 5px 10.5px #DDDDDD, inset 0 0 5.9px #EBEBEB, 0 6px 7.8px rgba(154, 154, 154, 0.3)',
};

export const RECORD_FILTER_CHIP_STYLES = {
	dateRange: {
		background: '#E1B7FF',
		color: '#AB1AFF',
	},
	site: {
		background: '#FDE1BA',
		color: '#895612',
	},
};

export const RECORD_STATUS_STYLES = {
	posted: {
		label: 'Posted',
		background: '#76EF9E4D',
		color: '#06742F',
	},
	default: {
		background: '#D9F7E1',
		color: '#078633',
	},
	strike: {
		label: 'Strike',
		background: 'linear-gradient(180deg, #01A13D 0%, #09632B 100%)',
		color: '#FFFFFF',
	},
	historyDenied: {
		label: 'Denied',
		background: '#E3E3E3',
		color: '#777777',
	},
	detailDenied: {
		label: 'Denied',
		background: '#DFDEE7',
		color: '#5E5D61',
	},
	historyVoided: {
		label: 'Voided',
		background: '#FFCFCF',
		color: '#FF3333',
	},
	detailVoided: {
		label: 'Voided',
		background: '#FFCFCF',
		color: '#FF2D2D',
	},
	historyInfo: {
		background: '#DCE4FF',
		color: '#3E63FF',
	},
	detailInfo: {
		background: '#B7C0FB',
		color: '#1634F2',
	},
	voidable: {
		label: 'Voidable',
		background: '#B7C0FB',
		color: '#1634F2',
	},
};
